(function ($) {

	bindEvents();

	function bindEvents() {
		$('body').on('click', onClickAnywhere);
	}

	function onClickAnywhere(e) {
		var $this = $(e.target);
		if ($this.is('.nav-language-current')) return;
		$('.nav-language').removeClass('nav-language-open');
	}

    $(".lang-dropdown .lang-wrapper").click(function (e) {
        e.stopPropagation();
    });

}(window.jQuery));

analytics.eventConfig.push({
	"target": ".nav-language",
	"codeId": "lsw",
	"events": [
		{
			"eventTarget": "a",
			"eventType": "click",
			"tags": {
				"event": "navigation",
				"componentName": "language switcher",
				"componentId": "lsw",
				"eventType": "language switcher internal navigation click",
				"elementType": "language switcher",
				"elementText": "",
				"destinationUrl": "",
				"parentName": ""
			}
		}
	]
});